module.exports = __webpack_public_path__ + "img/08e3543.png";